export default "__VITE_ASSET__BwIs8Cpw__"